import { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { VM } from '../VM';

import { Index as ToolCategories } from '../../__business/components/toolcategories/Index';
import { RenderAPI } from '../../__business/components/global/RenderAPI';
import { Switching } from '../../__business/components/swtiching/Index'
import { Settings } from '../../__business/components/settings/Index';
// import { JobPost } from '../../__business/components/jobposting/Index';
// import { AplcntList}  from '../../__business/components/jobposting/AplcntList';
import PznlTour from '../../__business/components/home/Modal/PznlTour';
import { PlcyPermission } from '../../__business/components/global/PlcyPermission';
// import {Index as Personalization } from '../../core/global/personalization/Index';
import { StartHere } from '../global/personalization/StartHere';
import Profile from '../../__business/components/profile/Index';


let view = VM();
    const Navigation = lazy(() => import(`../../__business/components/layouts/navigations${view}/Index`))
    const Home = lazy(() => import (`../../__business/components/home${view}/Index`))
    const Applicants = lazy(() => import (`../../__business/components/Applicants${view}/Index`))
    const JobPost = lazy(() => import (`../../__business/components/jobposting${view}/Index`))
    const OnboardX = lazy(() => import (`../../__business/components/OnboardX${view}/Index`))
    const Careers = lazy(() => import (`../../__business/components/careers${view}/Index`))

export const WebRoute = () => {
    const location = useLocation().pathname;
    return (
        <Switch>
            {/* HOME */}
            <Route exact path="/biz" render={props=>(Render(Home, props, location))}/>
            <Route exact path="/biz/applicants/:params" render={props=>(Render(Applicants, props, location))}/>
            <Route exact path="/biz/switching" render={props=><Switching/>} />
            <Route exact path="/biz/more" render={props=>(Render(Settings, props, location))} />
            <Route exact path="/biz/tool-categories/:params" render={props=>(Render(ToolCategories, props, location))} />
            <Route exact path="/biz/onboarding/:params" render={props=>(Render(OnboardX, props, location))} />
            <Route exact path="/biz/profile" render={props=>(Render(Profile, props, location))} />


            {/* JOBPOST ROUTES */}
            <Route exact path="/biz/job/:params" render={props=>(Render(JobPost, props))} />
             <Route exact path="/biz/careers/:params" render={props=>(Render(Careers, props))} />
            {/* 404 NOT FOUND */}
            <Route>
                <Container>
                    <Box display="flex">
                        Error 404
                    </Box>
                </Container>
            </Route>
        </Switch>
    )
}

const Render = (Component, props, location) => (
    <>
        {view === '' ? (
            <Box width="100%" height="100%">
                <Box width="100%" height="100%" display="flex">
                    <Box height="100%">
                        {(location !== '/biz/profiling') && (<Navigation side={1} />)}
                    </Box>
                    <Box display="flex" flexDirection="column" width="100%" height="100%" bgcolor='#fff'>
                        <Navigation side={0} />
                        <Box  height="100%" className="overflowY noScrollcss" >
                            <Component {...props} />
                            <PznlTour />
                        </Box>
                    </Box>
                </Box>
            </Box>
        ) : (
            <Box width="100%" height="100%" >
                <Box width="100%" height="100%" display="flex" flexDirection="column" >
                    {(location !== '/biz/profiling' && location !== '/biz/more') && (
                        <Box minHeight={location === '/biz' ? '92px' : '40px'}>
                            <Navigation side={0} />
                        </Box>
                    )}
                    <Box height="100%" width="100%" className="overflowY noScrollcss"><Component {...props} /></Box>
                    {(location !== '/profile' && location !== '/biz/profiling') &&
                        <Box minHeight="54px">
                            <Navigation side={2} />
                        </Box>
                    } 
                </Box>
            </Box>
        )}
        {/* FOR POLICY PERMISSION REQUIRED BEFORE TRANSACTION */}
        <PlcyPermission/>
        
        <RenderAPI/>
        <StartHere/>
    </>
)